import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const WhatsAppFloating = () => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => window.innerWidth < 640;
    const mobile = checkMobile();
    setIsMobile(mobile);

    if (mobile) {
      // On mobile, show after 10 seconds
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10000);
      return () => clearTimeout(timer);
    } else {
      // On desktop, show after scrolling 300px
      const handleScroll = () => {
        setIsVisible(window.scrollY > 300);
      };
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Check initial position
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.a
          href="https://api.whatsapp.com/send/?phone=41766270882&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-2 right-2 sm:bottom-6 sm:right-6 flex items-center gap-2"
          style={{ zIndex: 9999 }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.3 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          data-testid="whatsapp-floating-button"
        >
      {/* Expanded label on hover */}
      <AnimatePresence>
        {isHovered && (
          <motion.span
            className="bg-[#0a0a0a] border border-[#FFD700]/30 text-white text-xs tracking-wider px-4 py-2 rounded-full whitespace-nowrap"
            initial={{ opacity: 0, x: 10, width: 0 }}
            animate={{ opacity: 1, x: 0, width: 'auto' }}
            exit={{ opacity: 0, x: 10, width: 0 }}
            transition={{ duration: 0.2 }}
          >
            <span className="text-[#FFD700]">24/24</span> {t('contact.whatsapp_label')}
          </motion.span>
        )}
      </AnimatePresence>

      {/* Main button */}
      <motion.div
        className="relative w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#0a0a0a] border-2 border-[#FFD700] flex items-center justify-center shadow-lg shadow-[#FFD700]/20"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full border-2 border-[#FFD700]/50 animate-ping" />
        
        {/* WhatsApp icon */}
        <svg 
          className="w-5 h-5 sm:w-6 sm:h-6 text-[#FFD700] relative z-10" 
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </motion.div>
    </motion.a>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppFloating;
